import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('molten.dataViewers.aggregations.AggDeviceAttribute');
export default {
  name: 'aggResult.deviceId',
  get displayName() {
    return t('displayName');
  },
  valueType: 'string',
  objectType: 'aggResult',
  placement: {
    group: []
  },
  get: obj => {
    return obj?.key;
  }
};